{
  "APP_TITLE": "Prohlížeč písem",
  "SELECT_FONT": "Vybrat písmo",
  "SEARCH_FONTS": "Hledat písma...",
  "PREVIEW": "Náhled",
  "GLYPHS": "Glyfy",
  "DOWNLOAD": "Stáhnout",
  "FONT_SIZE": "Velikost písma",
  "SAMPLE_TEXT": "Ukázkový text",
  "SHOW_GLYPHS": "Zobrazit všechny glyfy",
  "VARIABLE_AXES": "Osové parametry",
  "NO_VARIABLE_AXES": "Toto písmo nemá osové parametry",
  "GLYPH_COUNT": "Glyfů",
  "FONT_INFO": "Info o písmu",
  "IS_VARIABLE": "Proměnné písmo",
  "YES": "Ano",
  "NO": "Ne",
  "COPIED": "Zkopírováno!",
  "CLICK_TO_COPY": "Kliknutím kopírovat"
}
